<template>
    <main id="main-content" role="main">
        <NuxtPage />
    </main>
</template>
<script setup lang="ts">
    useHead({
        meta: [
            { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
        ],
    })

    // BFCache 和模块加载错误处理已移至 plugins/module-error-handler.client.ts
</script>
